// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"Z0-z","displaySixCardTiles":"_0-z"};